import React, {  useState } from "react";
import styled from "styled-components";
import { DashboardFirst } from "../Components/Dashboard/DashboardFirst";
import { DashboardSecond } from "../Components/Dashboard/DashboardSecond/DashboardSecond";
import { colors } from "../Shared/colors";
import Footer from "../Components/Footer/Footer";

export const DashboardComponent = () => {
  
  const [staff, setStaff] = useState(null);

  return (
    <Main>
      <DashboardContainer>
        <DashboardFirst staff={staff} setStaff={setStaff}/>
        <DashboardSecond staff={staff} setStaff={setStaff} />
      </DashboardContainer>
      <Footer/>
    </Main>
  );
};

const Main = styled.div`
  background: ${colors.white};
  min-height: 100vh;
  width: 100%;
  padding: 2rem;
  position: relative;
  margin-top: 10vh; /* Add margin to account for navbar */
`;

const DashboardContainer = styled.div`
  position: relative;
  z-index: 1;
  max-width: 1400px;
  margin: 0 auto;
  background: ${colors.white};
  border-radius: 24px;
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
`;
